<template>
    <v-data-table
        v-model="selected"
        item-key="id"
        :headers="headers"
        :items="items"
        :custom-sort="customSort"
        sort-by="fulltNavn"
        height="calc(100vh - 370px)"
        :fixed-header="true"
        :loading="loading"
        loading-text="Henter"
        no-data-text=""
        :items-per-page="-1"
        show-select
        must-sort
        hide-default-footer
    >
        <template v-slot:item.profile="{ item }">
            <v-avatar size="40px" v-if="item.avatar">
                <img alt="Avatar" :src="item.avatar" />
            </v-avatar>
        </template>
        <template v-slot:item.select="{ item }">
            <v-checkbox class="v-input-data-item--checkbox" v-model="selected" :value="item.id" :hide-details="true"></v-checkbox>
        </template>
        <template v-slot:item.fulltNavn="{ item, index }">
            <td v-on:click="edit(index)" class="v-data-table-item--link">
                <a class="text-decoration-none">{{ item.fulltNavn }}</a>
            </td>
        </template>
        <template v-slot:item.samtykke.samtykket="{ item }">
            <span>
                {{ item.samtykke && item.samtykke.dato ? 'Ja' : '' }}
            </span>
        </template>
        <template v-slot:item.samtykke.nyhetsbrev="{ item }">
            <span>
                {{ item.samtykke && item.samtykke.nyhetsbrev ? 'Ja' : '' }}
            </span>
        </template>
        <template v-slot:item.samtykke.arrangement="{ item }">
            <span>
                {{ item.samtykke && item.samtykke.arrangement ? 'Ja' : '' }}
            </span>
        </template>
        <template v-slot:item.samtykke.marked="{ item }">
            <span>
                {{ item.samtykke && item.samtykke.marked ? 'Ja' : '' }}
            </span>
        </template>
        <template v-slot:item.samtykke.ingen="{ item }">
            <span>
                {{ item.samtykke && item.samtykke.ingen ? 'Ja' : '' }}
            </span>
        </template>
        <template v-slot:item.status="{ item }">
            <span>
                {{ item.statusNavn }}
            </span>
        </template>
        <template v-slot:item.tjeneste="{ item }">
            <span>
                {{ tjeneste(item) }}
            </span>
        </template>
        <template v-slot:item.sorgGrupper="{ item }">
            <span>
                {{ sorgGrupper(item) }}
            </span>
        </template>
        <template v-slot:item.oppstartsdato="{ item }"> {{ item.oppstartsdato | format('DD.MM.YYYY') }} </template>
        <template v-slot:item.sluttet="{ item }"> {{ item.sluttet | format('DD.MM.YYYY') }} </template>
        <template v-slot:item.frivilliginformasjon.taKontaktDato="{ item }">
            <span v-if="item.frivilliginformasjon">{{ item.frivilliginformasjon.taKontaktDato | format('DD.MM.YYYY') }}</span>
        </template>
        <template v-slot:item.frivilliginformasjon.kursDato="{ item }">
            <span v-if="item.frivilliginformasjon">{{ item.frivilliginformasjon.kursDato | format('DD.MM.YYYY') }}</span>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'PersonsDataTable',
    props: {
        value: {
            default: function () {
                return [];
            },
            type: Array,
        },
        personer: {
            type: Array,
            required: true,
        },
        view: {
            type: String,
            required: true,
        },
        status: {
            type: String,
        },
        showConsent: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        const headers = [
            { value: 'fulltNavn', text: 'Navn' },
            { value: 'frivilliginformasjon.tjeneste', text: 'Ønsket tjeneste' },
            { value: 'frivilliginformasjon.taKontaktDato', text: 'Ta kontakt' },
            { value: 'frivilliginformasjon.onsketOppstart', text: 'Når ønsker du oppstart?' },
            { value: 'frivilliginformasjon.kursDato', text: 'Kursdato' },
            { value: 'samtykke.samtykket', text: 'Samtykket' },
            { value: 'samtykke.nyhetsbrev', text: 'Nyhetsbrev' },
            { value: 'samtykke.arrangement', text: 'Arrangement' },
            { value: 'samtykke.marked', text: 'Marked' },
            { value: 'samtykke.ingen', text: 'Ingen av alt.' },

            { value: 'bydel', text: 'Bydel' },
            { value: 'status', text: 'Status', align: 'start' },
            { value: 'tjeneste', text: 'Tjeneste', align: 'start' },
            { value: 'sorgGrupper', text: 'Sorggruppe', align: 'start' },
            { value: 'oppstartsdato', text: 'Oppstart' },
            { value: 'sluttet', text: 'Sluttet' },
            { value: 'lopenummer', text: 'Nr' },
        ];

        return {
            allHeaders: headers,
            headers: headers,

            allSelected: false,
            selected: [],
            items: [],
        };
    },
    watch: {
        personer: function (items) {
            this.items = items;
        },
        view: function (value) {
            this.view = value || '';
            this.filterHeaders();
        },
        selected: function (value) {
            this.$emit('input', value);
        },
        showConsent: function () {
            this.filterHeaders();
        },
    },
    filters: {
        format: function (value, format) {
            return value ? value.format(format) : '';
        },
    },
    created: function () {
        this.filterHeaders();
    },
    methods: {
        /**
         * filterHeaders
         */
        filterHeaders: function () {
            this.headers = this.allHeaders.filter((header) => {
                switch (header.value) {
                    case 'frivilliginformasjon.tjeneste':
                    case 'frivilliginformasjon.taKontaktDato':
                    case 'frivilliginformasjon.onsketOppstart':
                    case 'frivilliginformasjon.kursDato':
                        return this.view.indexOf('FRIVILLIGIPROSESS') !== -1;

                    case 'samtykke.samtykket':
                    case 'samtykke.nyhetsbrev':
                    case 'samtykke.arrangement':
                    case 'samtykke.marked':
                    case 'samtykke.ingen':
                        return this.showConsent && this.view.indexOf('KONTAKT') !== -1;

                    case 'bydel':
                        return this.view.indexOf('HJEMME') > 0;

                    case 'tjeneste':
                        return this.view.endsWith('/');

                    case 'sorgGrupper':
                        return this.view.indexOf('SORG') > 0;

                    case 'lopenummer':
                        return this.view.indexOf('BRUKER') != -1;

                    case 'sluttet':
                        return this.status == 'SLUTTET';
                }
                return true;
            });
            this.$emit('fields', this.headers);
        },

        /**
         * tjeneste
         */
        tjeneste: function (person) {
            let tjeneste = '';
            if (person.roller) {
                const tjenester = [];
                for (const rolle of person.roller) {
                    switch (rolle.id) {
                        case 'FRIVILLIG_SORG':
                        case 'BRUKER_SORG':
                            tjenester.push('Sorgtjenesten');
                            break;

                        case 'FRIVILLIG_HJEMME':
                        case 'BRUKER_HJEMME':
                            tjenester.push('Besøk hjemme');
                            break;
                    }
                }
                tjeneste = tjenester.join(', ');
            }
            return tjeneste;
        },

        /**
         * sorgGrupper
         */
        sorgGrupper: function (person) {
            if (person.sorgGrupper) {
                const sorgGrupper = [];
                for (const sorgGruppe of person.sorgGrupper) {
                    sorgGrupper.push(sorgGruppe.tittel);
                }
                return sorgGrupper.join(', ');
            }
            return '';
        },

        /**
         * edit
         */
        edit: function (index) {
            this.$emit('edit', index);
        },

        /**
         * customSort
         */
        customSort: function (items, index, isDesc) {
            if (index.length) {
                items.sort((a, b) => {
                    switch (index[0]) {
                        case 'fulltNavn':
                            a = a.etternavn + ' ' + a.fornavn;
                            b = b.etternavn + ' ' + b.fornavn;
                            break;

                        case 'oppstartsdato':
                            a = a.oppstartsdato ? a.oppstartsdato : 0;
                            b = b.oppstartsdato ? b.oppstartsdato : 0;
                            return isDesc[0] ? a - b : b - a;

                        case 'frivilliginformasjon.taKontaktDato':
                            a = a.frivilliginformasjon && a.frivilliginformasjon.taKontaktDato ? a.frivilliginformasjon.taKontaktDato : 0;
                            b = b.frivilliginformasjon && b.frivilliginformasjon.taKontaktDato ? b.frivilliginformasjon.taKontaktDato : 0;
                            return isDesc[0] ? a - b : b - a;

                        case 'frivilliginformasjon.kursDato':
                            a = a.frivilliginformasjon && a.frivilliginformasjon.kursDato ? a.frivilliginformasjon.kursDato : 0;
                            b = b.frivilliginformasjon && b.frivilliginformasjon.kursDato ? b.frivilliginformasjon.kursDato : 0;
                            return isDesc[0] ? a - b : b - a;

                        case 'frivilliginformasjon.onsketOppstart': {
                            const rekkefolge = { '1-3 mnd': 1, '3-6 mnd': 2, 'Mer enn 6 mnd': 3 };
                            a = rekkefolge[a.frivilliginformasjon && a.frivilliginformasjon.onsketOppstart] || 4;
                            b = rekkefolge[b.frivilliginformasjon && b.frivilliginformasjon.onsketOppstart] || 4;
                            return isDesc[0] ? b - a : a - b;
                        }

                        case 'bydel':
                            a = a.bydel || '';
                            b = b.bydel || '';
                            break;

                        case 'status':
                            a = a.statusNavn;
                            b = b.statusNavn;
                            break;

                        case 'tjeneste':
                            a =
                                a.roller && a.roller.length
                                    ? a.roller
                                          .map((rolle) => rolle.navn)
                                          .sort()
                                          .join(', ')
                                    : '';
                            b =
                                b.roller && b.roller.length
                                    ? b.roller
                                          .map((rolle) => rolle.navn)
                                          .sort()
                                          .join(', ')
                                    : '';
                            break;

                        case 'sorgGrupper':
                            a = a.sorgGrupper && a.sorgGrupper.length ? a.sorgGrupper[0].tittel : '';
                            b = b.sorgGrupper && b.sorgGrupper.length ? b.sorgGrupper[0].tittel : '';
                            break;

                        default:
                            a = a.id;
                            b = b.id;
                    }

                    if (!isDesc[0]) {
                        return a.localeCompare(b, 'no', { numeric: true, sensitivity: 'base' });
                    } else {
                        return b.localeCompare(a, 'no', { numeric: true, sensitivity: 'base' });
                    }
                });
            }
            this.$emit('sorted', items);
            return items;
        },
    },
};
</script>
<style lang="scss" scoped></style>
